import { SiteFile } from "../models/site";
import axiosConfig from "./axiosConfig";

export type ExtractedUploadFields = Partial<
  Pick<
    SiteFile,
    | "description"
    | "invoiceNumber"
    | "invoiceAmount"
    | "invoiceDueDate"
    | "statementNumber"
    | "statementAmount"
    | "issueDate"
  >
>;

export interface ExtractInvoiceUploadFieldsResponse {
  fields: ExtractedUploadFields;
  // null when the PDF has no readable text or the site has nothing to compare against.
  mentionsSite: boolean | null;
}

const getExtractInvoiceUploadFields = async (
  authToken: string,
  siteId: string,
  fileGuid: string,
  fileName: string,
  fileType: string
): Promise<ExtractInvoiceUploadFieldsResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/invoice/extract_upload_fields?fileGuid=${encodeURIComponent(fileGuid)}&fileName=${encodeURIComponent(fileName)}&fileType=${encodeURIComponent(fileType)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getExtractInvoiceUploadFields;
